import { categoryLabels, flagLabels } from './AssessmentFlags.copy';
import { SeverityTone } from './AssessmentFlags.types';

const humanizeEnumValue = (value: string) =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim();

export const formatFlagLabel = (flagKey: string) =>
  flagLabels[flagKey] ?? humanizeEnumValue(flagKey);

export const formatCategoryLabel = (category: string) =>
  categoryLabels[category] ?? humanizeEnumValue(category);

export const formatSeverityLabel = (severity: string) => humanizeEnumValue(severity);

export const getSeverityTone = (severity: string): SeverityTone =>
  ['High', 'Severe'].includes(severity) ? 'severe' : severity === 'Watch' ? 'watch' : 'elevated';
